export const FETCH_REPORT_DETAILS = 'src/Corporate/report/action/Fetch_Report_Details';
export const FETCH_REPORT_DETAILS_SUCCESS = 'src/Corporate/report/action/Fetch_Report_Details_Success';
export const FETCH_REPORT_DETAILS_FAILURE = 'src/Corporate/report/action/Fetch_Report_Details_Failure';
export const fetchReportDetails = (data) => {
    return {
        type: FETCH_REPORT_DETAILS,
        data
    }
}
export const fetchReportDetailsSuccess = (data) => {
    return {
        type: FETCH_REPORT_DETAILS_SUCCESS,
        data
    }
}
export const fetchReportDetailsFailure = (data) => {
    return {
        type: FETCH_REPORT_DETAILS_FAILURE,
        data
    }
}

export const FETCH_PAYMENT_SCORE = 'src/Corporate/Credit-worthiness-dashboard/action/Fetch_Payment_Score';
export const FETCH_PAYMENT_SCORE_SUCCESS = 'src/Corporate/Credit-worthiness-dashboard/action/Fetch_Payment_Score_Success';
export const FETCH_PAYMENT_SCORE_FAILURE = 'src/Corporate/Credit-worthiness-dashboard/action/Fetch_Payment_Score_Failure';

export const fetchPaymentScore = (data) => {
    return {
        type: FETCH_PAYMENT_SCORE,
        data
    }
}
export const fetchPaymentScoreSuccess = (data) => {
    return {
        type: FETCH_PAYMENT_SCORE_SUCCESS,
        data
    }
}
export const fetchPaymentScoreFailure = (data) => {
    return {
        type: FETCH_PAYMENT_SCORE_FAILURE,
        data
    }
}

export const FETCH_CUG_SCORE = 'src/Corporate/Credit-worthiness-dashboard/action/Fetch_Cug_Score';
export const FETCH_CUG_SCORE_SUCCESS = 'src/Corporate/Credit-worthiness-dashboard/action/Fetch_Cug_Score_Success';
export const FETCH_CUG_SCORE_FAILURE = 'src/Corporate/Credit-worthiness-dashboard/action/Fetch_Cug_Score_Failure';

export const fetchCugScore = (data) => {
    return {
        type: FETCH_CUG_SCORE,
        data
    }
}
export const fetchCugScoreSuccess = (data) => {
    return {
        type: FETCH_CUG_SCORE_SUCCESS,
        data
    }
}
export const fetchCugScoreFailure = (data) => {
    return {
        type: FETCH_CUG_SCORE_FAILURE,
        data
    }
}

export const FETCH_PAYMENT_RISKGRADES = 'src/Corporate/Credit-worthiness-dashboard/action/Fetch_Payment_Riskgrades';
export const FETCH_PAYMENT_RISKGRADES_SUCCESS = 'src/Corporate/Credit-worthiness-dashboard/action/Fetch_Payment_Riskgrades_Success';
export const FETCH_PAYMENT_RISKGRADES_FAILURE = 'src/Corporate/Credit-worthiness-dashboard/action/Fetch_Payment_Riskgrades_Failure';

export const fetchPaymentRiskgrade = (data) => {
    return {
        type: FETCH_PAYMENT_RISKGRADES,
        data
    }
}
export const fetchPaymentRiskgradeSuccess = (data) => {
    return {
        type: FETCH_PAYMENT_RISKGRADES_SUCCESS,
        data
    }
}
export const fetchPaymentRiskgradeFailure = (data) => {
    return {
        type: FETCH_PAYMENT_RISKGRADES_FAILURE,
        data
    }
}

export const DATA_CHECK = 'src/Corporate/Credit-worthiness-dashboard/action/Data_Check';
export const DATA_CHECK_SUCCESS = 'src/Corporate/Credit-worthiness-dashboard/action/Data_Check_Success';
export const DATA_CHECK_FAILURE = 'src/Corporate/Credit-worthiness-dashboard/action/Data_Check_Failure';

export const dataCheck = (data) => {
    return {
        type: DATA_CHECK,
        data
    }
}
export const dataCheckSuccess = (data) => {
    return {
        type: DATA_CHECK_SUCCESS,
        data
    }
}
export const dataCheckFailure = (data) => {
    return {
        type: DATA_CHECK_FAILURE,
        data
    }
}

export const FETCH_REPORT_LIST_REQUEST = 'src/Corporate/Credit-worthiness-dashboard/action/Fetch_Report_List_Request';
export const FETCH_REPORT_LIST_RESPONSE = 'src/Corporate/Credit-worthiness-dashboard/action/Fetch_Report_List_Response';

export const fetchReportListRequest = (data) => {
    return {
        type: FETCH_REPORT_LIST_REQUEST,
        data
    }
}
export const fetchReportListResponse = (data) => {
    return {
        type: FETCH_REPORT_LIST_RESPONSE,
        data
    }
}

export const GET_ALL_SECTIONS = 'src/Corporate/Credit-worthiness-dashboard/Get_Sections';
export const GET_SECTION_SUCCESS = 'src/Corporate/Credit-worthiness-dashboard/Get_Section_Success';
export const GET_SECTION_FAILURE = 'src/Corporate/Credit-worthiness-dashboard/Get_Section_Failure';

export const getAllSections = (data) => {
    return {
        type: GET_ALL_SECTIONS,
        data
    }
}
export const sectionSuccess = (data) => {
    return {
        type: GET_SECTION_SUCCESS,
        data
    }
}
export const sectionFailure = (data) => {
    return {
        type: GET_SECTION_FAILURE,
        data
    }
}

export const SHOW_SECTION_PDF = 'src/Corporate/Credit-worthiness-dashboard/Show_Section_Pdf';
export const SHOW_SECTION_PDF_SUCCESS = 'src/Corporate/Credit-worthiness-dashboard/Show_Section_Pdf_Success'
export const SHOW_SECTION_PDF_FAILURE = 'src/Corporate/Credit-worthiness-dashboard/Show_Section_Pdf_Failure'
export const showSectionPdf = (data) => {
    return {
        type: SHOW_SECTION_PDF,
        data
    }
}
export const showSectionPdfSuccess = (data) => {
    return {
        type: SHOW_SECTION_PDF_SUCCESS,
        data
    }
}
export const showSectionPdfFailure = (data) => {
    return {
        type: SHOW_SECTION_PDF_FAILURE,
        data
    }
}

export const DOWNLOAD_REPORT_PDF = 'src/components/Cases/View/action/Download_Report_Pdf';
export const DOWNLOAD_REPORT_PDF_SUCCESS = 'src/components/Cases/View/action/Download_Report_Pdf_Success';
export const DOWNLOAD_REPORT_PDF_FAILURE = 'src/components/Cases/View/action/Download_Report_Pdf_Failure';
export const downloadReportPdf = (data,name) => {
    return {
        type: DOWNLOAD_REPORT_PDF,
        data,
        name
    }
}
export const downloadReportPdfSuccess = (data) => {
    return {
        type: DOWNLOAD_REPORT_PDF_SUCCESS,
        data
    }
}
export const downloadReportPdfFailure = (data) => {
    return {
        type: DOWNLOAD_REPORT_PDF_FAILURE,
        data
    }
}
export const BPR_STATUS = 'src/Corporate/Credit-worthiness-dashboard/action/BPR_Status';
export const BPR_STATUS_SUCCESS = 'src/Corporate/Credit-worthiness-dashboard/action/BPR_Status_Success';
export const BPR_STATUS_FAILURE = 'src/Corporate/Credit-worthiness-dashboard/action/BPR_Status_Failure';

export const updateBPRStatus = (data) => {
    return {
        type: BPR_STATUS,
        data
    }
}
export const updateBPRStatusSuccess = (data) => {
    return {
        type: BPR_STATUS_SUCCESS,
        data
    }
}
export const updateBPRStatusFailure = (data) => {
    return {
        type: BPR_STATUS_FAILURE,
        data
    }
}